
import React, {Fragment, useContext, useState} from 'react';
import { Resizer,FormContext } from 'wsc-react-custom-form';
import {Button, Modal} from 'antd';
import styled from 'styled-components';
import {useEditor, useNode} from "@craftjs/core";
import axios from "axios";
import { Settings } from './settings';

const defaultProps = {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: ['0', '0', '0', '0'],
    margin: ['0', '0', '0', '0'],
    background: { r: 255, g: 255, b: 255, a: 1 },
    color: { r: 0, g: 0, b: 0, a: 1 },
    shadow: 0,
    radius: 0,
    fillSpace: 'no',
    width: '100%',
    height: 'auto',
    disabled: 'false',
    visible: 'true',
    size: 'default', // mini
    type: 'primary', // 绿色/default 白色/warn 红色
    plain: 'false',
    text: '提交',
    name: 'ok',
    headers: {},
    successFlag: 'success',
    businessKey: 'data/id',
    api: '',
};

const StyledDiv = styled.div`
    border: 2px solid transparent;
    width: 92%;
    margin: 0 auto;
    `;

export const MiniFormDisposeButton = (props) => {
    props = {
        ...defaultProps,
        ...props,
    };
    const {
        name,

        disabled,
        size,
        type,
        plain,
        api,
        text,
        headers,
        url,
    } = props;


    const { form,OnPayload,axiosConfig, onBeforeSubmit } = useContext(FormContext);
    const [loading,setLoading] = useState(false);
    const {editorEnabled} = useEditor(state => ({
        editorEnabled: state.options.enabled,
    }));

    const handleClick = (e) => {
        e.preventDefault();
        if (editorEnabled) return;

        form.validateFields().then(async (values) => {
            try {
                setLoading(true);
                if (typeof onBeforeSubmit === 'function') {
                    values = onBeforeSubmit(values);
                }
                let targetUrl = ((api != null && api.indexOf("http")) > -1 ? api:((axiosConfig.baseURL?axiosConfig.baseURL:"") + api));
                let result = await axios(targetUrl, { method: "POST", data: Object.assign({},initdata,values), headers: {...axiosConfig.headers,...headers} })
                if (result.status == 200) {
                    //http请求成功
                    OnPayload(form, name, { formvalue: values, apiresult: result.data });
                } else {
                    Modal.error({ content: <Fragment><div>网络请求错误，错误代码：{result.status}</div><div>{result.statusText}</div></Fragment> });
                }
                setLoading(false);
            } catch (error) {
                Modal.error({ content: <Fragment><div>网络请求错误，错误代码：{error.status}</div><div>{error.message}</div></Fragment> });
                setLoading(false);
            };
        });
    }



    const {
        connectors: { connect },
    } = useNode((node) => ({
        selected: node.events.selected,
    }));

    return (
        <StyledDiv ref={connect} {...props} >
            <Button
                disabled={ disabled==='true' }
                size={size === 'default'? 'middle' : 'small'}
                type={['primary', 'default'].includes(type) ? type : 'default'}
                ghost={plain === 'true'}
                danger={type === 'warn'}
                onClick={handleClick}
                className='w-full'
                shape='round'
                loading={loading}
            >{text}</Button>
        </StyledDiv>
    );
};

MiniFormDisposeButton.category = "流程";
MiniFormDisposeButton.thumb = "https://via.placeholder.com/300x200.png";

MiniFormDisposeButton.craft = {
    displayName: 'MiniFormDisposeButton',
    props: {
        name: "time",
        border: true,
        required: true,
        rules: [{ required: true, message: "请输入XXX" }],
        labelSpan: 6,
        labelOffset: 0,
        wrapperSpan: 18,
        wrapperOffset: 0,
        url: '/api/v2/private/bpm/process/dispose',
        successFlag: 'success',
        businessKey: 'data/id',
        ...defaultProps
    },
    related: {
        toolbar: Settings,
    },
};

export default MiniFormDisposeButton;